import React, { memo, Suspense } from "react"

import InvitationList from "./InvitationList";
import CreateRoom from "./room/CreateRoom";
import HostedRoom from "./room/HostedRoom";
import InvitedRoom from "./room/InvitedRoom";
import GroupList from "./contact/GroupList";
import ContactList from "./contact/ContactList";
import Subscription from "./Subscription";
import MyRecordings from "./MyRecordings";
import MyDevices from "./MyDevices";
import { PaymentPages } from "./Utils";
import PaymentHistoryMain from "./paymentHistory/PaymentHistoryMain";


// const InvitationList = React.lazy(() => import("./InvitationList"));
// const CreateRoom = React.lazy(() => import("./room/CreateRoom"));
// const HostedRoom = React.lazy(() => import("./room/HostedRoom"));
// const InvitedRoom = React.lazy(() => import("./room/InvitedRoom"));
// const ContactList = React.lazy(() => import("./contact/ContactList"));
// const GroupList = React.lazy(() => import("./contact/GroupList"));
// const Subscription = React.lazy(() => import("./Subscription"));
// const MyRecordings = React.lazy(()=>import("./MyRecordings"));



const RenderContent = memo((props) => {
    const { selectedTab } = props;
    
    let component = null;
    if (selectedTab == PaymentPages.INVITATION_LIST) {
        component =  <InvitationList />
    } else if (selectedTab == PaymentPages.CREATE_ROOM) {
        component =  <CreateRoom />
    } else if (selectedTab == PaymentPages.UPDATE_ROOM) {
        component =  <CreateRoom
            pageType="update"
        />
    } else if (selectedTab == PaymentPages.HOSTED_ROOM) {
        component =  <HostedRoom />
    } else if (selectedTab == PaymentPages.INVITED_ROOM) {
        component =  <InvitedRoom />
    } else if (selectedTab == PaymentPages.MY_CONTACT) {
        component =  <ContactList />
    } else if (selectedTab == PaymentPages.CONTACT_GROUP) {
        component =  <GroupList />
    } else if (selectedTab == PaymentPages.SUBSCRIPTION) {
        component =  <Subscription />
    } else if(selectedTab == PaymentPages.MY_RECORDINGS){
        component = <MyRecordings />
    } else if(selectedTab == PaymentPages.PAYMENT_HISTORY){
        component = <PaymentHistoryMain />
    } else if(selectedTab == PaymentPages.MY_DEVICE){
        component = <MyDevices />
    }
    else{
        component =  <InvitationList />
    }

    return (
        <div className="tabs-content-inner">
            {/* <Suspense fallback={<div>loading...</div>}>
            </Suspense> */}
                {component}
        </div>
    )


})

export default RenderContent;